import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

export interface RequestQuery {
    category: string;
    idx: string;
}

export interface RequestBody {
    vTitle: string;
    vPopSizeW: number;
    vPopSizeH: number;
    vPopX: number;
    vPopY: number;
    cViewYN: string;
    cTodayYN: string;
    cPvL: string;
    vContent: string;
}

export type UpdateRequest = RequestQuery & RequestBody;

export interface updateResponse {
    statusCode: number;
    message: string;
    data: {
        idx: number;
    };
}

export const usePutConsolePopup = (
    successCallback?: (data: updateResponse) => void,
): UseMutationResult<updateResponse, Error, UpdateRequest, unknown> => {
    const queryClient = useQueryClient();

    return useMutation<updateResponse, Error, UpdateRequest>({
        mutationFn: async (updateData: UpdateRequest) => {
            const url = enum_api_uri.put_console_popup.replace(":category", updateData.category).replace(":idx", updateData.idx);
            const response = await axiosInstance.put(url, {
                vTitle: updateData.vTitle,
                vPopSizeW: updateData.vPopSizeW,
                vPopSizeH: updateData.vPopSizeH,
                vPopX: updateData.vPopX,
                vPopY: updateData.vPopY,
                cViewYN: updateData.cViewYN,
                cTodayYN: updateData.cTodayYN,
                cPvL: updateData.cPvL,
                vContent: updateData.vContent,
            });
            return response.data;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["useGetConsolePopupDetail"] });
            // successCallback?.(data);
        },
    });
};
